<template>
	<div>
		<myheader headTitle="存证报告"></myheader>
		<div class="all_main">
			<div class="all_list_content_nopadding" id="pdfcontainer"
				style="top: 4.2rem;bottom: 3.6rem; background-color: white;">
			</div>
		</div>
		<div class="all_tips_bottom_card">
			<button class="all_button24 width_100 text16 backgroundC_main bmain_active"
				@click="downFileClick()">下载</button>
		</div>
	</div>
</template>

<script>
	import {
		getDeviceType,
		saveFileToDownloads,
		fromateDownloadPath
	} from '../../utils/nativeOtherOperate.js';
	import {
		setEssToken
	} from "../../utils/cookies.js";
	export default {
		data() {
			return {
				//合同编号
				contractCode: '',
				//iframe高度
				iframeHeight: '85vh',
			}
		},
		methods: {
			//下载当前附件文件
			downFileClick() {
				let that = this
				const url = window.location.origin + process.env.VUE_APP_API_BASE_URL_MSIGN +
					'/evidence/api/getEvidenceReport?contractCode=' + this.contractCode
				const header = 'Bearer ' + window.localStorage.getItem("Identity_Token")
				switch (getDeviceType()) {
					case 'android':
					case 'ios':
						let time = Date.now()
						let fileName = '_downloads/document_' + time + '.pdf'
						let aFileName = fromateDownloadPath('downloads/document_' + time + '.pdf')
						this.$store.dispatch(this.$LoadShow, true)
						this.$store.dispatch(this.$LoadText, '下载中...')
						let task = plus.downloader.createDownload(url, {
							filename: fileName,
						}, function(d, status) {
							that.$store.dispatch(that.$LoadShow, false)
							that.$store.dispatch(that.$LoadText, '加载中...')
							if (status === 200) {
								if (saveFileToDownloads(aFileName, this.contractCode + '.pdf')) {
									that.$Toast('下载文件成功')
								}else{
											that.$Toast('下载文件失败，请重试！')
										}
							} else {
								that.$Toast('下载文件失败，请重试！')
							}
						})
						task.setRequestHeader('Authorization', header);
						task.start()
						break
					case 'harmony':
						this.$store.dispatch(this.$LoadShow, true)
						this.$store.dispatch(this.$LoadText, '下载中...')
						harmonyEsign.downFileToSanBox(header, url)
							.then(res => {
								//console.log('downFileToSanBox-=', res)
								if (res) {
									harmonyEsign.copySanFileToManager(res).then(rel => {
										//console.log('copySanFileToManager-=', rel)
										that.$store.dispatch(that.$LoadShow, false)
										that.$store.dispatch(that.$LoadText, '加载中...')
										if(rel){
											that.$Toast('下载文件成功')
										}else{
											that.$Toast('下载文件失败，请重试！')
										}
									}).catch(err => {
										console.log('copySanFileToManager-err-=', err)
										that.$store.dispatch(that.$LoadShow, false)
										that.$store.dispatch(that.$LoadText, '加载中...')
										that.$Toast('下载文件失败，请重试！')
									})
								}else{
									that.$store.dispatch(that.$LoadShow, false)
									that.$store.dispatch(that.$LoadText, '加载中...')
									that.$Toast('下载文件失败，请重试！')
								}
							}).catch(err => {
								console.log('downFileToSanBox-err-=', err)
								that.$store.dispatch(that.$LoadShow, false)
								that.$store.dispatch(that.$LoadText, '加载中...')
								that.$Toast('下载文件失败，请重试！')
							})
						break;
				}
			},
			//
			setIframeSrc() {
				this.iframeHeight = document.getElementById('pdfcontainer').clientHeight
				this.$store.dispatch(this.$LoadShow, true)
				const fileUrl = process.env.VUE_APP_API_BASE_URL_MSIGN + '/evidence/api/getEvidenceReport?contractCode=' +
					this.contractCode
				const src = window.location.origin + process.env.VUE_APP_PREVIEW_URL + '/h5/preview/preview.html?file=' +
					encodeURIComponent(fileUrl) + '&Authorization=Bearer ' + window.localStorage.getItem("Identity_Token")
				console.log('--src--=', src)
				let theFrag = document.createDocumentFragment()
				let theIframe = document.createElement('iframe');
				theIframe.setAttribute('id', 'Iframe_0');
				theIframe.setAttribute('class', 'iframe-style');
				theIframe.setAttribute('style', 'height:' + this
					.iframeHeight + 'px');
				theIframe.setAttribute('src', src);
				theFrag.appendChild(theIframe);
				document.getElementById('pdfcontainer').appendChild(theFrag)
			},
			//接受处理iframe消息
			handlerMessage() {
				let that = this
				window.addEventListener('message', (event) => {
					let postData = event.data.data;
					if (postData && postData.type) {
						switch (postData.type) {
							//显示iframe中的消息
							case 'toast':
								that.$Toast(postData.data)
								break;
								//pdf加载时改弹窗消失
							case 'loaded':
								that.$store.dispatch(that.$LoadShow, false)
								break;
						}
					}
				})
			},
			//初始化
			init() {
				this.contractCode = this.$route.query.contractCode
				this.setIframeSrc()
				this.handlerMessage()
			},
		},
		mounted() {
			this.init()
		},
		created() {},
		beforeDestroy() {
			//自动回收
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>